'use client'

import React, { useEffect, useState } from 'react'
import Image from 'next/image'
import { CHALLAN_LODING_GIF } from '@components/MainWidget/common/widgetImagesConstant'
import { handleLoaderUpdate } from '@components/MainWidget/common/helper'
import { CHALLAN_LOADER_SCREEN_TEXTS, LOADING_ALT } from './challanConstants'
import styles from './challanModal.module.scss'

const ChallanLoadingScreen = ({ setChallanLoadingScreen, regNo }) => {
  const [currentLoaderIndex, setCurrentLoaderIndex] = useState<number>(0)
  const onComplete = () => {
    setChallanLoadingScreen(false)
  }
  useEffect(() => {
    const cleanup = handleLoaderUpdate(currentLoaderIndex, setCurrentLoaderIndex, onComplete)
    return cleanup
  }, [currentLoaderIndex, CHALLAN_LOADER_SCREEN_TEXTS.length, onComplete])
  return (
    <div className={styles.loader}>
      <Image src={CHALLAN_LODING_GIF} alt={LOADING_ALT} width={370} height={100} layout="fixed" priority />
      <div className={styles.regNo}>{regNo}</div>
      <p className={styles.loaderText}>{CHALLAN_LOADER_SCREEN_TEXTS[currentLoaderIndex]}</p>
    </div>
  )
}

export default ChallanLoadingScreen
